var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    attrs: {
      "slot": "content",
      "id": "drag-and-drop-comparisons"
    },
    slot: "content"
  }, [!_vm.shouldShowKeyboard ? _c('section', {
    staticClass: "questionSection"
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea",
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleDragContainerEnterEvent();
      }
    }
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "startingPoint",
      attrs: {
        "id": ("startingPoint-" + (item.id))
      }
    }, [_c('div', {
      class: ['draggableItem', {
        'element-selected': _vm.isElementSelected(item)
      }],
      attrs: {
        "aria-label": _vm.comparisonLabelText(item.label),
        "data-id": ("" + (item.id)),
        "id": ("draggable-" + (item.id)),
        "tabindex": _vm.isGuessed(item) ? -1 : 10,
        "role": "button"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDraggableItemEnterEvent(item.id, true);
        }
      }
    }, [_c('div', {
      staticClass: "dragAndDropContent",
      style: {
        background: _vm.getDragContentBackground(item)
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])])]);
  }), 0)]), _c('div', {
    staticClass: "droppableArea"
  }, _vm._l(_vm.currentRound.dropZones, function (item, index) {
    var _vm$getAssociatedHint;
    return _c('div', {
      key: item.id,
      staticClass: "dropItemContainer",
      attrs: {
        "role": "region"
      }
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.leftHtml
      }
    }), _c('div', {
      class: ['droppableItem', _vm.getDroppableItemClass(), {
        'selectable-answer': !!_vm.selectedElement
      }],
      style: {
        backgroundColor: ((_vm.getDroppableBackground(item)) + " !important")
      },
      attrs: {
        "id": ("dropArea-" + (item.id)),
        "tabindex": _vm.isGuessedCorrectly(item) ? -1 : 10
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDroppableItemEnterEvent(("dropArea-" + (item.id)), true);
        }
      }
    }, [_vm.isGuessedCorrectly(item) && !_vm.shouldShowKeyboard ? _c('CorrectIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.isGuessedIncorrectly(item) && !_vm.shouldShowKeyboard ? _c('WrongIcon', {
      attrs: {
        "height": "36px",
        "width": "36px"
      }
    }) : _vm._e(), _vm.showCorrectAnswers && !_vm.isGuessedCorrectly(item) && !_vm.isSubmitted ? _c('div', {
      staticClass: "dragAndDropContent correctAnswerContent"
    }, [_vm._v("\n                " + _vm._s((_vm$getAssociatedHint = _vm.getAssociatedHintItem(item.correctItemIds, ("The correct input for equation " + (index + 1) + " is %."))) === null || _vm$getAssociatedHint === void 0 ? void 0 : _vm$getAssociatedHint.label) + "\n              ")]) : _vm._e()], 1), _c('html-renderer', {
      attrs: {
        "htmlObject": item.rightHtml
      }
    })], 1);
  }), 0)]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "element": "div",
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e()])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }